// PORTED FROM apps/web — see apps/web-employer/PORTING.md (or web-admin/) for follow-ups

import { Lock, Users } from "lucide-react";
import { EmptyState, SkeletonCard } from "@chotca/ui";
import type { PostingState } from "@chotca/config";
import { useApplicants } from "@chotca/api-client";
import { ApplicantRow } from "@/components/applicant-row";
import { ErrorState } from "@/components/error-state";

export function ApplicantsTab({
  postingId,
  orgId,
  postingState,
}: {
  postingId: string;
  orgId: string;
  postingState: PostingState;
}) {
  const { data, isLoading, isError, refetch } = useApplicants(postingId);
  const isActive = postingState === "OPEN";

  if (isLoading) {
    return (
      <div className="space-y-3">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>
    );
  }

  if (isError) {
    return <ErrorState onRetry={() => refetch()} />;
  }

  if (!data || data.items.length === 0) {
    return (
      <EmptyState
        icon={<Users className="h-7 w-7" />}
        title="Chưa có ứng viên nào"
        description="Khi có người ứng tuyển, hồ sơ sẽ hiển thị tại đây."
      />
    );
  }

  return (
    <div className="space-y-3">
      {!isActive ? (
        <div className="flex items-start gap-3 rounded-2xl border-[1.5px] border-smoke bg-mist/40 px-4 py-3 text-sm text-ink">
          <Lock size={16} className="mt-0.5 shrink-0 text-ash" />
          <p>
            Tin tuyển dụng đã đóng. Bạn không thể xem hồ sơ hoặc liên hệ ứng
            viên mới — chỉ xem được các liên hệ đã mở trước đó.
          </p>
        </div>
      ) : null}
      {data.items.map((a) => (
        <ApplicantRow
          key={a.application.id}
          applicant={a}
          postingId={postingId}
          orgId={orgId}
          postingActive={isActive}
        />
      ))}
    </div>
  );
}
